import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import data from "../../../datasets/usecases/creditbureau";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const CreditBureau = () => {
  return (
    <div className="credit_bureau_landing">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      {/* <Resources {...data} /> */}
      {/* <PricingGetStarted /> */}
    </div>
  );
};
